import React, { useContext } from "react";
import { SiteSettingsContext } from "../context/SiteSettingsContext";
import { isNullOrWhiteSpace } from "../shared/string";
import { CardLink } from "./CardLink";

export type MarketSelectorPortableTextProps = {
  title?: string;
};

export const MarketSelectorPortableText = (props: MarketSelectorPortableTextProps) => {
  const { title } = props;

  const { markets } = useContext(SiteSettingsContext);

  if (!markets?.length) {
    return null;
  }

  return (
    <aside className="relative z-10">
      {!isNullOrWhiteSpace(title) && <h2 className="text-current">{title}</h2>}
      <ul className="flex flex-wrap lg:justify-start lg:-mx-4 overflow-visible pb-6">
        {markets.map((market, index) => {
          const flagUrl = `https://flagcdn.com/${market.flagId}.svg`;

          return (
            <li key={index} className="w-full lg:w-6/12 xl:w-4/12 lg:px-4 mb-6">
              <CardLink
                title={market.title}
                href={market.url}
                imgUrl={flagUrl}
                imgRole="presentation"
                imgWidth={18}
                imgHeight={18}
              />
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

